import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { ArrowLeft, MessageSquare } from "lucide-react";

export default function KBArticlePage() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    api.get(`/kb/${id}`).then((r) => setArticle(r.data)).catch(() => {});
  }, [id]);

  if (!article) return <div className="p-12 text-zinc-400 text-sm">Loading…</div>;

  return (
    <div className="p-8 lg:p-12 max-w-3xl" data-testid="kb-article">
      <Link
        to="/app/kb"
        className="inline-flex items-center gap-1 text-sm text-zinc-500 hover:text-zinc-900 mb-6 transition"
        data-testid="back-to-kb"
      >
        <ArrowLeft className="w-4 h-4" /> Back to knowledge base
      </Link>

      <div className="text-xs uppercase tracking-[0.3em] font-bold text-blue-600 mb-3">{article.category}</div>
      <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl text-zinc-900 mb-4">
        {article.title}
      </h1>
      <p className="text-lg text-zinc-500 mb-10">{article.summary}</p>

      <div className="bg-white rounded-3xl border border-zinc-200 p-8 lg:p-10 mb-8">
        <pre className="font-sans text-zinc-800 whitespace-pre-wrap leading-relaxed text-[15px]">{article.content}</pre>
      </div>

      <div className="bg-zinc-900 text-white rounded-3xl p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <div className="font-display font-bold text-lg">Still need help?</div>
          <p className="text-zinc-400 text-sm">Chat with our AI Assistant or file a ticket.</p>
        </div>
        <Link
          to="/app/chat"
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold px-5 py-3 rounded-full transition-all hover:-translate-y-0.5"
          data-testid="kb-chat-cta"
        >
          <MessageSquare className="w-4 h-4" /> Open chat
        </Link>
      </div>
    </div>
  );
}
